import { selectAllNodes, selectNode } from './helpers';
import { addToHeaderCart } from './small-cart';
import zipcodesModal from './zipcodeModal';


//Add to cart submitted products with packages and cards
export function addToCart(productsToAdd, isModified = false) {
  const endEvent = new CustomEvent('product-submited');
  const startEvent = new CustomEvent('submit-started');
  document.dispatchEvent(startEvent);

  return jQuery
    .ajax({
      url: window.sharedResources.ajaxurl,
      type: 'POST',
      data: {
        action: 'add-to-cart',
        data: {
          products: productsToAdd,
          isModified: isModified
        }
      }
    })
    .done(data => {
      if (data) addToHeaderCart(data);
      endEvent.customData = data;
      document.dispatchEvent(endEvent);
    });
}

// Fetch zipcodes and products list from db
export function getZipcodes() {
  return jQuery
    .ajax({
      url: window.sharedResources.ajaxurl,
      type: 'POST',
      data: {
        action: 'get-zipcodes'
      }
    })
    .fail(function({ status, statusText }) {
      console.error(`status - ${status}: ${statusText}`);
    });
}

// get additional features data
function getAdditional(wrapper) {
  const packages = [
    ...wrapper.querySelectorAll('.pa_presentinslagning .package-and-cards')
  ];
  const cards = [
    ...wrapper.querySelectorAll('.pa_halsningskort .package-and-cards')
  ];

  const otherTerms = [
    ...wrapper.querySelectorAll(
      '.single-product__form__attributes .package-and-cards'
    )
  ];

  const customPrice = wrapper.querySelector('#price')

  const getAdditionalData = (result, { checked, value, dataset }) =>
    checked
      ? { name: dataset.additional, termId: dataset.termid, value }
      : result;

  const getOtherTerms = (
    result,
    { checked, dataset: { taxname, additional } }
  ) => {
    if (checked) {
      result[taxname] = result[taxname]
        ? [...result[taxname], additional]
        : [additional];
    }
    return result;
  };

  return {
    package: packages.length ? packages.reduce(getAdditionalData, {}) : {},
    cards: cards.length ? cards.reduce(getAdditionalData, {}) : {},
    otherTerms: otherTerms.length ? otherTerms.reduce(getOtherTerms, {}) : {},
    customPrice: customPrice ? customPrice.value : {}
  };
}

//Handle product add to cart
export function handleSubmit(wrapper) {
  return async function(e) {
    e.preventDefault();
    const productsCount = selectAllNodes('wa-cart-link-counter');
    const additional = getAdditional(wrapper);
    const qty = selectNode('qty', wrapper).value;
    const id = e.target.dataset.id;
    const cardTextEl = selectNode('cardText', wrapper);
    const noCardInput = wrapper.querySelector("[data-slug = \"inget-kort\"]");
    const cardText = cardTextEl && (noCardInput && !noCardInput.checked) ? cardTextEl.value : '';
    const submitedProductsIds = [{ id, qty, additional, cardText }];
    const customPrice = wrapper.querySelector('#price');

    const warning = document.createElement('span')
      warning.classList.add('warning')
      warning.style.color = '#cc2323'
    
      if (customPrice || cardTextEl) {
          if (!wrapper.querySelector(".warning")) {
              wrapper.classList.contains("acc-modal__content")
                  ? cardTextEl.after(warning)
                  : wrapper.appendChild(warning);
          }

          if (customPrice && parseInt(customPrice.value) > parseInt(customPrice.max)) {
              wrapper.querySelector(".warning").innerHTML = "Högsta pris: " + customPrice.max;
          } else if (customPrice && parseInt(customPrice.value) < parseInt(customPrice.min) || (customPrice && !customPrice.value)) {
              wrapper.querySelector(".warning").innerHTML = "Lägsta pris: " + customPrice.min;
          } else {
              wrapper.querySelector(".warning").innerHTML = "";

              if (cardTextEl && cardTextEl.value.length < 2 && (!noCardInput || !noCardInput.checked)) {
                  wrapper.querySelector(".warning").innerHTML = "Korttext är obligatoriskt fält";
              } else {
                  wrapper.querySelector(".warning").innerHTML = "";
                  wrapper.classList.add("loading");
                  await addToCartAfterCheck();
              }
          }
      } else {
          await addToCartAfterCheck();
      }


     async function addToCartAfterCheck(){
          if (productsCount.some(el => !parseInt(el.innerText, 10))) {
              const zipcodes = await getZipcodes()
              zipcodesModal(zipcodes, submitedProductsIds)
          } else {
              addToCart(submitedProductsIds)
          }
      }

  };
}

// change 'checked' statuses of checkboxes and radiobuttons
const toggleColorNodes = colorNodes => ({ target }) => {
  const isMassToggleNodes = node =>
    node.dataset.slug === 'mixed' || node.dataset.slug === 'season-color';

  if (isMassToggleNodes(target) && target.checked) {
    colorNodes.map(el => {
      if (target !== el) el.checked = false;
    });
  } else if (target.checked) {
    colorNodes.map(el => {
      if (isMassToggleNodes(el)) el.checked = false;
    });
  }
};

// show/hide container with color checkboxes
const handleColorNodeWrapperToggle = wrapper => ({ target }) => {
  if (!target.classList.contains('color-terms')) {
    wrapper.classList.add('show');
  } else {
    wrapper.classList.remove('show');
  }
};

// show/hide band colors
const handleBandColorToggling = ({ target }) => {
  const bandColorsWrapper = selectNode('band-color');
  if (!bandColorsWrapper) return;

  const radioButtons = selectAllNodes('package-and-cards', bandColorsWrapper);

  if (bandColorsWrapper && target.dataset.slug === 'begravningsband') {
    bandColorsWrapper.classList.add('show');
  } else {
    bandColorsWrapper.classList.remove('show');
    radioButtons.map(el => {
      el.checked = false;
    });
  }
};

// INIT cart functionality
async function cartScripts() {
  const submitWrapper = selectAllNodes('single-product__form');
  const modal = selectNode('delivery-modal');
  const colorNodesWrapperToggler = selectAllNodes('radio-input');
  const colorNodesWrapper = document.querySelector(
    '.pa_color .term-choices-wrapper'
  );
  const colorTerms = selectAllNodes('color-terms');
  const bandColorSelector = [
    ...document.querySelectorAll('.pa_halsningskort input')
  ];


  if (bandColorSelector.length)
    bandColorSelector.map(el =>
      el.addEventListener('click', handleBandColorToggling)
    );

  submitWrapper.map(wrapper => {
    const addToCartBtn = selectNode('add-to-cart', wrapper);
    const customPrice =  wrapper.querySelector('#price');

      const cardInput = wrapper.querySelectorAll('[name="pa_halsningskort"]')

      if (cardInput) {
          cardInput.forEach(input => {
              input.addEventListener("change", () => {
                  if (input.dataset.slug === "inget-kort" && input.checked) {
                      selectNode("cardText", wrapper).parentNode.style.display = "none";
                  } else {
                      selectNode("cardText", wrapper).parentNode.style.display = "block";
                  }
              });
          });
      }

      if (customPrice) {
          customPrice.placeholder = 'Varuvärde'
      }

    addToCartBtn.addEventListener('click', handleSubmit(wrapper));
    addToCartBtn.classList.remove('disabled');
  });

  if (colorTerms.length) {
    colorNodesWrapperToggler.map(el =>
      el.addEventListener(
        'change',
        handleColorNodeWrapperToggle(colorNodesWrapper)
      )
    );
    colorTerms.map(el =>
      el.addEventListener('change', toggleColorNodes(colorTerms))
    );
  }
}

export default cartScripts;
